import { getShopperId, updateAuthTokens } from '@exp/exp-utils/helper/auth'
import { getVisitorId } from '@exp/exp-utils/helper/visitor'
import { hivemindConstants } from '@godaddy/hivemind-common'

import HivemindClient from './hivemind-client'

export const browserSdkKeys = {
  dev: 'mbqv2tai7f3k04c7rm4dnombdfuvvddtmgku',
  test: 'k0kgs7d57kss5jbkfsdto70ierl2tgvivl0v',
  prod: 'pbqj1rfhsn00ukm2lv96jcg4rmbktkrdsmm0'
}

// This factory function returns an initialized HivemindClient.
// It is *only* meant to be used in conjuction with the UXP headers where
// teams are setting `hivemind: true` in their request to Presentation Central
function getClient ({
  readyTimeout,
  mockData,
  usePreload,
  Client = HivemindClient
} = {}) {
  const { ux: { data: { app = 'default', env = 'dev' } = {} } = {} } = window

  updateAuthTokens()
  const shopperId = getShopperId()
  const visitorGuid = getVisitorId()
  const hivemind = new Client({
    app: app.replace(/\./g, '-'),
    splitioOptions: {
      core: {
        authorizationKey: browserSdkKeys[env]
      }
    },
    subject: {
      ...shopperId && { [hivemindConstants.idTypes.SHOPPER_ID]: shopperId },
      ...visitorGuid && { [hivemindConstants.idTypes.VISITOR_GUID]: visitorGuid }
    },
    preloadLocation: '__hivemindPreload',
    readyTimeout,
    mockData,
    usePreload
  })

  return hivemind.ready.then(() => hivemind)
}

export default getClient
